import {
  addPendingRequestIdForConversation,
  clearPendingRequest,
} from 'actions/composition/lib/update_conversation_workflow';
import { createContent } from 'scripts/domain/factories/conversation_item/create_item_content';
import { isEmpty } from 'models/composition/composition_content_shared';
import createConversationNoteItem from 'scripts/domain/factories/conversation_item/create_conversation_note_item';
import Err from 'models/err';
import IdGenerator from 'scripts/domain/contracts/id_generator';
import { handleCommonErrors } from 'scripts/application/lib/gateway_error_interactive_handler';
import SubmitComposition, { getOutgoingItemDto } from 'actions/composition/lib/submit_composition';

export default class AddNote extends SubmitComposition {
  createOutgoingItems(composition, composedContent) {
    let compositionErrors = composition.validateAttachmentStatus();
    compositionErrors = compositionErrors.concat(composition.validateTotalAttachmentSize());
    if (isEmpty(composedContent.bodyHtml) && composition.attachments.length === 0) {
      compositionErrors = compositionErrors.concat([
        new Err({
          attr: 'bodyHtml',
          code: Err.Code.BLANK,
          detail: 'editor is empty',
        }),
      ]);
    }

    if (compositionErrors.length) {
      return { compositionErrors };
    }

    const noteContent = createContent(composition, composedContent);
    const note = createConversationNoteItem({
      agentProfile: this.currentAgent,
      content: noteContent,
      conversationId: this.activeConversation.id,
      customerId: composition.customerId,
      snippetIds: composition.snippetIds,
    });

    return { compositionErrors: [], conversationItems: [note] };
  }

  sendMessage(conversationUpdates, noteItem) {
    const requestId = IdGenerator.newId();
    addPendingRequestIdForConversation(this.context, noteItem.conversationId, requestId);
    this.context.gateways.conversationNote
      .add({ conversationId: conversationUpdates.id }, getOutgoingItemDto(noteItem))
      .catch(err => handleCommonErrors(this.context, err))
      .finally(() => {
        clearPendingRequest(this.context, requestId);
      });
  }
}
